import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
export const DOMAINS = ['All', 'CARE', 'Commission', 'Retail', 'Digital'];
const DomainContext = createContext(null);
const STORAGE_KEY = 'flowdoc:domain';
function readStoredDomain() {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && DOMAINS.includes(stored)) {
        return stored;
    }
    return 'All';
}
export function DomainProvider({ children }) {
    const [domain, setDomain] = useState(readStoredDomain);
    useEffect(() => {
        window.localStorage.setItem(STORAGE_KEY, domain);
    }, [domain]);
    const value = useMemo(() => ({ domain, setDomain }), [domain]);
    return _jsx(DomainContext.Provider, { value: value, children: children });
}
export function useDomain() {
    const context = useContext(DomainContext);
    if (!context) {
        throw new Error('useDomain must be used within a DomainProvider');
    }
    return context;
}
